var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAlipay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 16.4292V4.61436C24 2.06765 21.9324 0 19.3837 0H4.61436C2.06765 0 0 2.06675 0 4.61436V19.3848C0 21.9314 2.06571 23.9991 4.61436 23.9991H19.3847C21.6549 23.9991 23.5431 22.3576 23.928 20.1997C22.7041 19.6698 17.4005 17.3795 14.6369 16.0605C12.5337 18.6081 10.3317 20.1363 7.01227 20.1363C3.69288 20.1363 1.47736 18.0917 1.74326 15.5902C1.91885 13.9477 3.04489 11.2618 7.93859 11.7226C10.5169 11.9645 11.6977 12.4464 13.7998 13.1404C14.3442 12.144 14.7963 11.0449 15.1389 9.87761H5.81426V8.9532H10.4276V7.29446H4.80058V6.27693H10.4286V3.88095C10.4286 3.88095 10.4795 3.50666 10.8932 3.50666H13.2008V6.27603H19.2004V7.29356H13.2008V8.9523H18.0956C17.6454 10.7838 16.9628 12.4665 16.1076 13.9362C17.5292 14.4507 24 16.4292 24 16.4292ZM6.64456 18.5515C3.137 18.5515 2.58222 16.3369 2.76847 15.4116C2.95269 14.491 3.96828 13.2882 5.91894 13.2882C8.15934 13.2882 10.1666 13.8632 12.5759 15.0344C10.8836 17.2393 8.8044 18.5515 6.64456 18.5515Z",
    fill: "currentcolor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlipay);
export default __webpack_public_path__ + "static/media/alipay.3e65d4ae.svg";
export { ForwardRef as ReactComponent };